// Schermkeuzes per persoon (0042_widgets; golf 6b). Handgeschreven zoals push.ts en gelijk aan de
// API (apps/api/src/routes/v1/app/ui.ts); openapi.contract.test.ts bewaakt elke aanroep.
export function createUiClient(t) {
    return {
        get: () => t.request('GET', '/v1/app/ui-preferences'),
        save: (input) => t.request('PUT', '/v1/app/ui-preferences', input),
    };
}
//# sourceMappingURL=ui.js.map